<script>
  import { createEventDispatcher } from "svelte";
  import { link } from "../util/anchor-link";

  const dispatch = createEventDispatcher();
  export let inline = false;
  export let publish = false;
  export let external = false;
  export let upper = false;
  export let active = true;
  export let to = null;
  export let blocky = false;
  export let anchor = null;
  export let button = false;
</script>

<!-- <Link {to} class="abstract-link-button"> -->
<a
  href={to}
  target={external ? "_blank" : undefined}
  class:hasLink={to || anchor || button}
  class:inline
  class:publish
  class:upper
  class:active
  class:blocky
  class="link-button"
  use:link
  on:click={(ev) => {
    if (anchor) {
      const el = document.querySelector(`#${anchor}`);
      if (el) {
        ev.preventDefault();
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
    dispatch("click", ev);
  }}
>
  <slot></slot>
</a>

<style>
  .link-button {
    --color: currentColor;
    --shadow-color: currentColor;
    /* --background: white; */
    --down-background: hsl(0, 0%, 85%);
    /* position: relative; */
    font: inherit;
    color: var(--color);
    margin: 0;
    text-decoration: none;

    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;

    appearance: none;
    /* background: white; */
    box-sizing: border-box;
    /* border-radius: 33px; */
    /* min-width: 50px; */

    /* box-shadow: 2px 2px 0 var(--shadow-color); */
    outline: 0;
    overflow: hidden;
    cursor: default;

    /* padding: 10px 20px; */
    /* line-height: 1.2; */
    /* vertical-align: baseline; */
    /* margin-left: calc(-10px + 8px); */
    /* margin-right: calc(-6px + 6px); */
  }
  .active {
    border-bottom: 1px solid var(--shadow-color);
  }
  .hasLink {
    cursor: pointer;
  }
  .upper {
    text-transform: uppercase;
  }
  .inline {
    /* padding: 1px 10px; */
  }
  .publish {
    --color: white;
    --background: green;
    background: var(--background);
    border-color: var(--shadow-color);
  }
  .blocky {
    padding: 20px;
    border: 1px solid black;
    font-size: 16px;
    box-shadow:
      0px 2px 0px black,
      2px 2px 0px black,
      2px 0px 0px black;
  }
  /* .link-button:hover {
    text-decoration: none;
  } */
</style>
